import DialogContent from './DialogContent';
export * from './DialogContent';
export default DialogContent;